export default "__VITE_ASSET__D0osDAhp__"